import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Gates the whole IPM domain — both the left-nav entry (domainDefinition.ts) and the
// top-level route wrapper (itemPriceManagementRouter.tsx) consume this config. The
// minICPlatformVersion ties IPM to the R2026_08 release train (CP-955): external retailers
// only see it once their site is on r2026_08_0, while the itemPriceManagement feature toggle
// stays as a secondary kill-switch (ANDed with the version). Internal users bypass the version
// check by default and can emulate other versions via Admin Controls.
export const itemPriceManagementAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.itemPriceManagement],
  permissions: [Permission.ItemPriceManagementView],
  minICPlatformVersion: ICPlatformVersion.r2026_08_0,
}

export const itemPriceManagementViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementView],
}

export const itemPriceManagementModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementModify],
}

export const itemPriceManagementDeleteChangeRequestAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDeleteChangeRequest],
}

export const itemPriceManagementReviewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementReview],
}

export const itemPriceManagementPartnerApproveAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementPartnerApprove],
}

export const itemPriceManagementDebugAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDebug],
}
